import React from 'react'
import PageLayout from '../../components/layouts/PageLayout'
import CustomNavbar from '../../components/common/CustomNavbar'
import EmbeddedSignup from './EmbeddedSignup'

export default function Onboarding() {
    return (
        <PageLayout customNavbar={
            <CustomNavbar>
                <div className="flex gap-3 items-center w-max">
                    <span className="font-bold text-lg uppercase">onboarding</span>
                </div>
            </CustomNavbar>
        }>
            <div className="flex flex-col items-center justify-center gap-6 p-20">
                <h2 className="text-xl font-semibold">Connect Your WhatsApp Business Account</h2>
                <p className="text-gray-500 text-sm text-center max-w-md">
                    Click the button below to link your WhatsApp Business account via Facebook's Embedded Signup flow.
                </p>
                <EmbeddedSignup />
            </div>
        </PageLayout>
    )
}